import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

interface CategoryTabsProps {
  active: string;
  onSelect: (slug: string) => void;
}

export default function CategoryTabs({ active, onSelect }: CategoryTabsProps) {
  return (
    <section className="py-6">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-2 overflow-x-auto pb-2 scrollbar-hide">
          {categories.map((cat) => (
            <button
              key={cat.slug}
              onClick={() => onSelect(cat.slug)}
              className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm transition-all duration-200 whitespace-nowrap cursor-pointer ${
                active === cat.slug
                  ? 'bg-primary-500 text-background-50 font-medium'
                  : 'bg-background-100 text-foreground-600 hover:bg-background-200'
              }`}
            >
              <i className={`${cat.icon} text-sm`}></i>
              {cat.name}
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}